import { Card } from "../components/Card";
import { Disclaimer } from "../components/Disclaimer";
import { PageHeader } from "../components/PageHeader";
import { services } from "../lib/constants";

export function Services() {
  return (
    <>
      <PageHeader
        eyebrow="الخدمات"
        title="خدمات هندسية موجهة للتمويل والتأمين وإدارة الأصول"
        description="تغطي الخدمات تقييم الأضرار والحالة الفنية، تقدير تكلفة الإصلاح، التقارير الفنية والتأمينية، والإشراف على أعمال الإصلاح والترميم."
      />
      <section className="py-20">
        <div className="container grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <Card key={service.title}>
              <h2 className="text-xl font-bold text-charcoal">{service.title}</h2>
              <p className="mt-3 leading-8 text-ash">{service.description}</p>
            </Card>
          ))}
        </div>
      </section>
      <section className="bg-sand py-12">
        <div className="container">
          <Disclaimer />
        </div>
      </section>
    </>
  );
}
